import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import FilterShowcase from "@/components/FilterShowcase";
import Features from "@/components/Features";
import AiStudio from "@/components/AiStudio";
import Steps from "@/components/Steps";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Landing() {
    return (
        <div className="min-h-screen bg-obsidian">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <FilterShowcase />
                <Features />
                <AiStudio />
                <Steps />
                <Footer />
            </main>
            <WhatsAppFloat />
        </div>
    );
}
